import { useEffect, useState } from "react";

import { decoColumns } from "./misc/deco-columns";
import { parseUrl } from "@src/utility/helpers/utils";
import useAxios from "@hooks/use-axios";
import { useForm } from "react-hook-form";
import { useParams } from "react-router-dom";
import useSearchParams from "@hooks/use-search-params";

const defaultValues = {
    company_name: "",
    csm         : "",
    sdr         : "",
    product     : "",
    stage       : "",
    kpis        : [],
    groupBy     : []
};

const useReport = () => {

    const { platformId } = useParams();   
    const { axiosInstance, loading, cancelAllRequests } = useAxios({
        base         : "panel",
        initialLoader: true
    });
    const [data, setData] = useState({ reports: [], pagination: {}, total: 0 });
    const { appendUrl, getSearchParams } = useSearchParams();
    const [queryParams, setQueryParams] = useState({});
    const [appliedGroupBy, setAppliedGroupBy] = useState([
        "csm",
        "sdr",
        "company_name"
    ]);
    const methods = useForm({
        defaultValues
    });

    const { handleSubmit, reset, setValue } = methods;

    const getReport = async () => {
    // @ts-ignore
        const { data, pagination, total, metadata } = await axiosInstance.get(`/report/${platformId}`, {
            params: {
                start: getSearchParams("start"),
                end  : getSearchParams("end"),
                ...queryParams
            }
        });
        setData({
            reports   : data,
            total     : total?.totalMRR || 0,
            pagination: pagination || {}
        });
        setValue("groupBy", metadata.groupBy);
        setValue("kpi", metadata.kpis);
    };
 
    const onSubmit = () => {
        handleSubmit((data) => {
            const kpis = Array.isArray(data.kpis) ? data.kpis.join(",") : data.kpis;
            const groupBy = Array.isArray(data.groupBy) ? data.groupBy.join(",") : data.groupBy;

            setAppliedGroupBy(data.groupBy || []);

            const queryParams = {
                kpis,
                groupBy,
                // @ts-ignore
                ...(data.csm ? { csm: data.csm.value } : {}),
                // @ts-ignore
                ...(data.sdr ? { sdr: data.sdr.value } : {}),
                ...(data.stage ? { stage: data.stage.value } : {})
            };
           
            appendUrl(parseUrl({
                start: getSearchParams("start"),
                end  : getSearchParams("end"),
                ...queryParams
            }));
            setQueryParams(queryParams);
        })();
    };

    const onReset = () => {
        reset(defaultValues);
    };

    useEffect(() => {
        let isActive = true;

        if (isActive) {
            getReport();
        }

        return () => {
            isActive = false;
            cancelAllRequests();
        };
    }, [queryParams]);

    return {
        data,
        loading,
        columns: decoColumns(appliedGroupBy),
        getReport,
        onSubmit,
        onReset,
        methods
    };
};

export default useReport;
